import React from 'react'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { connect } from 'react-redux'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import LKButton from 'shared/LKButton'
import RefinListModal, { openRefinModal } from './RefinListModal'
import translate, { translateLKMessage } from '../../translator'
import ConditionAdd, { constants as ConditionAddConstants } from '../../../ConditionAdd'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'
import { withConstantPermissions } from '../../../shared'

import { ConditionsProps, Condition } from '../../types.LoanDetails'
import { AppDispatch } from 'src/store/index.d'
import { deleteCondition, deleteConditionsLoading } from 'src/store/loan'

const NAME_FOR_FETCHER = 'DeleteCondition'

const DLConfig = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_conditions',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: true,
  enableRowSelection: true,

  columnConfigs: {
    ChangeDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    InterestRate: {
      cellStyle: { textAlign: 'right' },
    },

    PenaltyPriRate: {
      cellStyle: { textAlign: 'right' },
    },

    PenaltyIntRate: {
      cellStyle: { textAlign: 'right' },
    },

    AdvFeeRate: {
      cellStyle: { textAlign: 'right' },
    },

    UCLCRate: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_PenaltyGrace: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_PenaltyPriority: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_AccrueInterestExpire: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_AccruePenaltyExpire: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_LimitPenalties: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_PenaltyDayOne_Amount: {
      cellStyle: { textAlign: 'right' },
    },

    GracePeriod_InterestAccrual: {
      cellStyle: { textAlign: 'right' },
    },

    CFG_PenaltyDayOne_MinAmount: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

//@ts-ignore
@connect(
  (state) => ({
    // loading: getPending(NAME_FOR_FETCHER)(state),
    loading: deleteConditionsLoading(state),
  }),
  (dispatch: AppDispatch, ownProps: ConditionsProps) => ({
    openConfirmation: ({ ID, HashSum_ConditionID_ }: { ID: number; HashSum_ConditionID_: string }) => {
      dispatch(
        LKModalActions.openConfirmation('LoanConditionsDeleteConfirmation', {
          message: translateLKMessage('CONFIRM_CONDITION_DELETE'),
          ConditionID: ID,
          ConditionHash: HashSum_ConditionID_,
        }),
      )
    },

    openHistory: (args: any) => {
      dispatch(LKModalActions.open(args))
    },

    openConditionAdd: () => {
      dispatch(LKModalActions.open({ name: ConditionAddConstants.MODAL_NAME }))
    },

    openRefinListModal: () => {
      dispatch(openRefinModal(ownProps.ID, ownProps.hash))
    },

    deleteCondition: ({ ConditionID, ConditionHash }: { ConditionID: number; ConditionHash: string }) => {
      const params = {
        LoanID: ownProps.ID,
        HashSum_LoanID_: ownProps.hash,
        ConditionID,
        HashSum_ConditionID_: ConditionHash,
      }

      // dispatch(
      //   fetchSFM({
      //     instanceName: NAME_FOR_FETCHER,
      //     callApi: Loan.deleteCondition,
      //     callApiArgs: [params],
      //     resolve: () => {
      //       dispatch(
      //         DetailsContainerActions.fetchPage({
      //           type: 'Loan',
      //           ID: ownProps.ID,
      //           hash: ownProps.hash,
      //           page: 'base',
      //         }),
      //       )

      //       dispatch(
      //         DetailsContainerActions.fetchPage({
      //           type: 'Loan',
      //           ID: ownProps.ID,
      //           hash: ownProps.hash,
      //           page: 'conditions',
      //         }),
      //       )
      //     },
      //     reject: (error) => {
      //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page:conditiondelete
      dispatch(deleteCondition(params)).then((result) => {
        if (!deleteCondition.fulfilled.match(result)) {
          dispatch(LKModalActions.openInfo(translateLKMessage(result.payload as string)))
          return
        }
        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Loan',
            ID: ownProps.ID,
            hash: ownProps.hash,
            page: 'base',
          }),
        )

        dispatch(
          DetailsContainerActions.fetchPage({
            type: 'Loan',
            ID: ownProps.ID,
            hash: ownProps.hash,
            page: 'conditions',
          }),
        )
      })
    },
  }),
)
//@ts-ignore
@withConstantPermissions(['ADD_LOAN_CONDITION', 'ADD_LOAN_CONDITION_LMB'])
class Conditions extends React.Component<ConditionsProps> {
  getContextItems = ({ node: { data } }: { node: { data: Condition } }) => [
    {
      name: translate('cmd_delete_condition'),
      icon: 'delete',
      action: () => this.props.openConfirmation(data),
      permissionKey: `DELETE_LOAN_CONDITION${this.props.base.ProductType === 4 ? '_LMB' : ''}`,
    },
  ]

  render() {
    const {
      instanceName,
      data,
      base,
      ProductID,
      ProductHash,
      loading,
      ADD_LOAN_CONDITION,
      ADD_LOAN_CONDITION_LMB,
      openRefinListModal,
      openConditionAdd,
      deleteCondition,
    } = this.props

    return (
      <>
        <RefinListModal />
        <div className="u-fluid u-relative u-flex u-directionColumn">
          <div className="u-fluid u-relative">
            <LKGrid
              instanceName={instanceName}
              rowData={data}
              getContextMenuItems={this.getContextItems}
              {...DLConfig}
            />
          </div>

          <div className="u-padding-5 u-flex u-spaceBetween">
            {base.IsArrested !== 1 &&
            ((base.ProductType === 4 && ADD_LOAN_CONDITION_LMB) || (base.ProductType !== 4 && ADD_LOAN_CONDITION)) ? (
              <LKButton
                alias="add"
                onClick={openConditionAdd}
                permission={`ADD_LOAN_CONDITION${base.ProductType === 4 ? '_LMB' : ''}`}
              >
                {translate('cmd_add_condition')}
              </LKButton>
            ) : (
              <div />
            )}

            <LKButton onClick={openRefinListModal} alias="transactions">
              {translate('cmd_irr_refin')}
            </LKButton>

            <ConditionAdd ProductID={ProductID} ProductHash={ProductHash} />

            <LKModal.Confirmation
              name="LoanConditionsDeleteConfirmation"
              onConfirm={deleteCondition}
              loading={loading}
            />
          </div>
        </div>
      </>
    )
  }
}

export default Conditions
